import { runClientComponent } from '../../_common/client/client-component-runner';
import { OffersPriceFeatureComponentComponent } from './offers-price-feature-component.component';

runClientComponent({ OffersPriceFeatureComponentComponent });
